import { ref } from '@vue/composition-api'
import useHttpPost from 'states/generics/useHttpPost'
import useHttpGet from 'states/generics/useHttpGet'

export default function useConnectWithStartup({ startupId, is_obfuscated }) {
  const url = '/events/start-chat-with-startup'
  const { postInProgress, post } = useHttpPost({ url, sleep: 2000 })

  const { isConnected, threadId, fetchConnection, fetchConnectionInProgress } =
    useFetchConnection({ startupId, is_obfuscated })

  const connect = async ({ message }) => {
    console.log(` => useConnectWithStartup
    startupId: ${startupId}
    `)

    await post({ startup_id: startupId, message })
    await fetchConnection()
  }

  return {
    connect,
    postInProgress,

    isConnected,
    threadId,
    fetchConnectionInProgress,
  }
}

function useFetchConnection({ startupId, is_obfuscated: isObfuscated }) {
  const isConnected = ref(false)
  const threadId = ref(null)
  const fetchUrl = `/startups/${startupId}/meta-info`
  const { getInProgress: fetchConnectionInProgress, get } = useHttpGet({
    url: fetchUrl,
  })
  const fetchConnection = async () => {
    const response = await get()
    if (response.data.thread_id) {
      threadId.value = response.data.thread_id
      isConnected.value = true
    }
  }

  if (startupId && !isObfuscated) fetchConnection()

  return {
    isConnected,
    threadId,
    fetchConnection,
    fetchConnectionInProgress,
  }
}
